import React from 'react'
import {  FaTwitter, FaLinkedinIn, FaGithub, FaRebel } from "react-icons/fa";
import { contactImg } from '../../assets';

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
     <div className="flex flex-col gap-4">
    <h3 className="text-3xl font-bold text-white">Sodiq Alabi</h3>
    <p className="text-lg font-normal text-gray-400">Fullstack Developer</p>
    {/* <p className="text-base text-gray-400 tracking-wide">
        Experienced fullstack developer with a passion for creating robust and scalable web applications. Proficient in front-end and back-end technologies, I enjoy tackling complex challenges and delivering high-quality solutions. 
    </p> */}
    <p className="text-base text-gray-400 flex items-center gap-2">
        Phone: <span className="text-lightText">+234 8076570048</span>
    </p>
    <p className="text-base text-gray-400 flex items-center gap-2">
        Email: <span className="text-lightText">alabisdq@gmail.com</span>
    </p>
</div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me on</h2>
        <div className="flex gap-4">
          <a href="https://www.github.com/tbossun">
            <span className="bannerIcon">
              <FaGithub />
            </span>
          </a>
          <a href="https://twitter.com/Ola_tunboss">
            <span className="bannerIcon">
              <FaTwitter />
            </span>
          </a>
          <a href="https://www.linkedin.com/sodiq-alabi">
            <span className="bannerIcon">
              <FaLinkedinIn />
            </span>
          </a>
          <a href="https://replit.com/@olatboss">
            <span className="bannerIcon">
              <FaRebel />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default ContactLeft